import "./RefrigeratedTrailers.module.css";
import Navbar from "@/reusable_sections/Header";
import Lineup from "./sections/Lineup";
import Features from "./sections/Features";
import CallToAction from "./sections/CallToAction";
import Specifications from "./sections/Specifications";
import Footer from "@/reusable_sections/Footer";
import FiftyThree from "./sections/FiftyThree";
export default function RefrigeratedTrailersPage() {
  return <div>
      <Navbar />
      <Lineup />
      <FiftyThree />
      <Features />
      <Specifications />
      <CallToAction />
      <Footer />
    </div>;
}